FreeTextView = require("../free-text-survey/view")

class FreeTextContributioView extends FreeTextView
  userInput: ->
    contribution:
      text: @value
      question:
        content: @options.data.question.content
        id: @options.data.question.id

module.exports = FreeTextContributioView
